export default "__VITE_ASSET___A3HEBB9__"